import axios from "axios";

export const INQUIRY_URL =
  process.env.REACT_APP_INQUIRY_URL ||
  "https://kyro.singularitybd.net/api/v1/smart-inquiry-store";

// Plain axios on purpose: the shared `api` instance attaches our admin token and 401 redirect.
export function submitSmartInquiry({
  name,
  work_email,
  company,
  phone,
  primary_use_case,
  description,
}) {
  return axios.post(
    INQUIRY_URL,
    {
      name: (name || "").trim(),
      work_email: (work_email || "").trim(),
      company: (company || "").trim(),
      phone: (phone || "").trim(),
      primary_use_case: (primary_use_case || "").trim(),
      description: (description || "").trim(),
    },
    { headers: { "Content-Type": "application/json" } }
  );
}

export function errorMessage(err) {
  const data = err?.response?.data;
  if (typeof data?.detail === "string") return data.detail;
  if (typeof data?.message === "string") return data.message;
  if (data?.errors && typeof data.errors === "object") {
    const first = Object.values(data.errors).flat()[0];
    if (typeof first === "string") return first;
  }
  return null;
}

// Runs the local save and the external inquiry together; succeeds if either one lands.
export async function submitBoth(localRequest, externalRequest) {
  const [local, external] = await Promise.allSettled([localRequest, externalRequest]);
  if (local.status === "rejected") console.warn("Local inquiry save failed", local.reason);
  if (external.status === "rejected") console.warn("Kyro inquiry API failed", external.reason);
  if (local.status === "fulfilled" || external.status === "fulfilled") return;
  throw new Error(
    errorMessage(external.reason) ||
      errorMessage(local.reason) ||
      "Could not submit. Please try again."
  );
}
